import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import TeamPlayersFB from '../components/Public/FootballAPI/Team/TeamTemplates/TeamPlayersFB';
import LegendStats from '../components/Public/Team/LegendStats';
import TeamCoaches from '../components/Public/Team/TeamCoaches';
import TeamSquad from '../components/Public/Team/TeamSquad';
import TeamSquadAPI from '../components/Public/FootballAPI/Team/TeamSquad'

import ViewJarallax from '../components/View/ViewJarallax';
import { firestore } from '../firebase';
import StateContext from '../StateContext';
import TeamFixtures from '../components/Public/FootballAPI/Team/TeamFixtures';

function SingleTeamPage() {

    const {id} = useParams();

    const appState = useContext(StateContext)

    const [team, setTeam] = useState()
    const [activeItem, setActiveItem] = useState("1");

    useEffect(() => {

        try {
            const teamRef = firestore.collection("teams").doc(id);
            teamRef.onSnapshot(doc => {
                const team = {id: doc.id, ...doc.data()}
                setTeam(team)
            })
        } catch (error) {
            
        }

    }, [id])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    return (
        <div>
            <ViewJarallax logo={team && team.team_logo} text={team && team.team_name} />

            <div className="container my-3">

                
                <div className="row">
                    <div className="col-4">
                        <button onClick={() => toggle("1")} className={`btn btn-light btn-block ${activeItem === "1" && "active"}`}>Oversikt</button>
                    </div>
                    <div className="col-4">
                        <button onClick={() => toggle("2")} className={`btn btn-light btn-block ${activeItem === "2" && "active"}`}>Tropp</button>
                    </div>
                    <div className="col-4">
                        <button onClick={() => toggle("3")} className={`btn btn-light btn-block ${activeItem === "3" && "active"}`}>Kamper</button>
                    </div>
                </div>

                        {activeItem === "1" && (
                            <React.Fragment>
                                {appState.loggedIn && appState.isAdmin && (
                                    <Link to={`/edit-team/${id}`}>
                                        <i className="fas fa-edit"></i>
                                    </Link>
                                )}
                                <h2 className="my-5">Statistikk</h2>
                                <LegendStats teamId={id} limit={25} />
                                <TeamCoaches teamId={id} />
                                <TeamSquad teamId={id} />
                            </React.Fragment>
                        )}

                        {activeItem === "2" && (
                            <React.Fragment>
                                <TeamCoaches teamId={id} />
                                <TeamSquad teamId={id} />

                                {team && team.api_id && (
                                    <React.Fragment>
                                        <TeamPlayersFB teamId={team.api_id} />
                                        <TeamSquadAPI id={team.api_id} /> 
                                    </React.Fragment>
                                )}

                           
                            </React.Fragment>
                        )}
                        {activeItem === "3" && (
                            <React.Fragment>
                                {team && team.api_id ? (
                                    <TeamFixtures id={team.api_id} />
                                ) : 
                                <p>Ingen kamper funnet</p>
                                }
                            </React.Fragment>
                        )}

            </div>
        </div>
    )
}
export default SingleTeamPage